/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoadmapMilestoneMarkerDto
 */
export interface RoadmapMilestoneMarkerDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapMilestoneMarkerDto
     */
    milestoneId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapMilestoneMarkerDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapMilestoneMarkerDto
     */
    targetDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof RoadmapMilestoneMarkerDto
     */
    status?: string;
}

/**
 * Check if a given object implements the RoadmapMilestoneMarkerDto interface.
 */
export function instanceOfRoadmapMilestoneMarkerDto(value: object): value is RoadmapMilestoneMarkerDto {
    return true;
}

export function RoadmapMilestoneMarkerDtoFromJSON(json: any): RoadmapMilestoneMarkerDto {
    return RoadmapMilestoneMarkerDtoFromJSONTyped(json, false);
}

export function RoadmapMilestoneMarkerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapMilestoneMarkerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'milestoneId': json['milestoneId'] == null ? undefined : json['milestoneId'],
        'name': json['name'] == null ? undefined : json['name'],
        'targetDate': json['targetDate'] == null ? undefined : (new Date(json['targetDate'])),
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function RoadmapMilestoneMarkerDtoToJSON(json: any): RoadmapMilestoneMarkerDto {
    return RoadmapMilestoneMarkerDtoToJSONTyped(json, false);
}

export function RoadmapMilestoneMarkerDtoToJSONTyped(value?: RoadmapMilestoneMarkerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'milestoneId': value['milestoneId'],
        'name': value['name'],
        'targetDate': value['targetDate'] == null ? undefined : ((value['targetDate']).toISOString().substring(0,10)),
        'status': value['status'],
    };
}

